import { useState } from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import '../styles/Popular.css';
import { Link } from "react-router-dom";
import { WeeklyContextMenu } from './WeeklyContextMenu';
import { useData } from '../contexts/DataContext';

function Popular() {
  const { recipes, weeklyMeals } = useData();

  // Sort alphabetically, same as before
  const sortedRecipes = [...recipes].sort((a, b) => a.title.localeCompare(b.title));

  const [contextMenu, setContextMenu] = useState(null);

  const handleContextMenu = (e, recipe) => {
    e.preventDefault();
    setContextMenu({ x: e.clientX, y: e.clientY, recipe });
  };

  return (
    <div>
      {contextMenu && (
        <WeeklyContextMenu
          x={contextMenu.x}
          y={contextMenu.y}
          recipe={contextMenu.recipe}
          weeklyMeals={weeklyMeals}
          onClose={() => setContextMenu(null)}
        />
      )}

      {/* Special Meal Options */}
      <div style={{ display: 'flex', gap: '20px', marginBottom: '30px', justifyContent: 'center' }}>
        <div className="image-container"
          onContextMenu={(e) => handleContextMenu(e, { id: 'dine-out', title: 'Dine Out' })}
          style={{ cursor: 'context-menu', maxWidth: '200px' }}>
          <img src="/images/dine-out.jpg" alt="Dine Out"
            style={{ display: "block", padding: "8px", borderRadius: "16px", width: "100%" }} />
          <div className="image-text">Dine Out</div>
        </div>
        <div className="image-container"
          onContextMenu={(e) => handleContextMenu(e, { id: 'delivery', title: 'Delivery' })}
          style={{ cursor: 'context-menu', maxWidth: '200px' }}>
          <img src="/images/delivery.jpg" alt="Delivery"
            style={{ display: "block", padding: "8px", borderRadius: "16px", width: "100%" }} />
          <div className="image-text">Order In / Delivery</div>
        </div>
        <div className="image-container"
          onContextMenu={(e) => handleContextMenu(e, { id: 'date-night', title: 'Date Night' })}
          style={{ cursor: 'context-menu', maxWidth: '200px' }}>
          <img src="/images/date-night.jpg" alt="Date Night"
            style={{ display: "block", padding: "8px", borderRadius: "16px", width: "100%" }} />
          <div className="image-text">Date Night</div>
        </div>
      </div>

      {/* Recipe Grid */}
      <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3, 1200: 4, 1500: 5, 1800: 6 }}>
        <Masonry>
          {sortedRecipes.map((recipe) => (
            <div key={recipe.id} className="image-container" onContextMenu={(e) => handleContextMenu(e, recipe)}>
              <Link to={`/recipe/${recipe.id}`} style={{ textDecoration: "none", color: "black" }}>
                <img height={"100%"} width={"100%"} src={recipe.image} alt={recipe.title}
                  loading="lazy" decoding="async"
                  style={{ display: "block", padding: "8px", borderRadius: "16px" }} />
              </Link>
              <div className="image-text">{recipe.title}</div>
            </div>
          ))}
        </Masonry>
      </ResponsiveMasonry>
    </div>
  );
}

export default Popular;